import React, { SVGProps } from 'react';
const paperAirplane = (props: SVGProps<SVGSVGElement>): JSX.Element => <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 31 32" {...props}><path d="M2.573 27.52 29.44 16 2.573 4.48l-.013 8.96L21.76 16l-19.2 2.56z" /></svg>;
export default paperAirplane;